import { RouteResponse as Route } from '@busie/api'
import { FlexContainer, palette, Text } from '@busie/ui-kit'
import { styled } from '@mui/material/styles'
import { metersToMiles } from '@busie/utils'
import { secondsToMinutes } from '~/helpers'
import React from 'react'

const InfoTitle = styled(Text)({
  fontSize: '12px',
  color: palette.black.plus40,
  lineHeight: '18px',
  fontWeight: 600,
})

const InfoSubtitle = styled(Text)({
  fontSize: '12px',
  color: palette.black.plus40,
  lineHeight: '18px',
  fontWeight: 500,
})

const InfoValue = styled(Text)({
  fontSize: '12px',
  color: palette.black.main,
  lineHeight: '18px',
  fontWeight: 500,
})

const Divider = styled('div')`
  width: 100%;
  height: 1px;
  background-color: ${palette.black.plus80};
`

interface Props {
  route: Route
}

const BasicInfo: React.FC<React.PropsWithChildren<Props>> = ({ route }) => {
  return (
    <FlexContainer px={2} direction="column" rowGap={1.33} fullWidth>
      <FlexContainer>
        <InfoTitle>BASIC INFORMATION</InfoTitle>
      </FlexContainer>
      <Divider />
      <FlexContainer justify="space-between" fullWidth>
        <InfoSubtitle>Total distance</InfoSubtitle>
        <InfoValue>{metersToMiles(route.totalDistance)} mi</InfoValue>
      </FlexContainer>
      <Divider />
      <FlexContainer justify="space-between" fullWidth>
        <InfoSubtitle>Travel time</InfoSubtitle>
        <InfoValue>{secondsToMinutes(route.estimateTravelTime)} min</InfoValue>
      </FlexContainer>
      <Divider />
      <FlexContainer justify="space-between" fullWidth>
        <InfoSubtitle>Toll Cost</InfoSubtitle>
        <InfoValue>${route.tollCost}</InfoValue>
      </FlexContainer>
    </FlexContainer>
  )
}

export default BasicInfo
